export default "__VITE_ASSET__BmPOk0k5__"